export const o1Criteria = [
  {
    id: 1,
    name: "Awards",
    nameZh: "奖项",
    description:
      "Nationally or internationally recognized prizes or awards for excellence in the field.",
    descriptionZh: "在专业领域获得国家级或国际级认可的卓越奖项或荣誉。",
    strongExamples: [
      "NSF CAREER Award or equivalent federal research grant",
      "Best Paper Award at a top-tier conference (e.g., NeurIPS, ACM, IEEE)",
      "National fellowship or scholarship with competitive selection (e.g., Fulbright, Rhodes)",
      "Industry-recognized innovation award (e.g., MIT Technology Review 35 Under 35)",
    ],
    strongExamplesZh: [
      "NSF CAREER奖或同等联邦研究基金",
      "顶级会议最佳论文奖（如NeurIPS、ACM、IEEE）",
      "竞争性国家奖学金（如富布赖特、罗德奖学金）",
      "行业认可创新奖（如MIT科技评论35岁以下35人）",
    ],
    weakExamples: [
      "Dean's list or departmental honors",
      "Company internal performance awards",
      "Participation certificates from conferences",
      "University-level scholarships without competitive selection",
    ],
    weakExamplesZh: [
      "院长名单或系级荣誉",
      "公司内部绩效奖",
      "会议参与证书",
      "无竞争性选拔的大学奖学金",
    ],
    actions: [
      "Apply to nationally recognized competitions in your field",
      "Submit papers to top-tier conferences with best paper award tracks",
      "Apply for competitive fellowships and research grants",
      "Nominate yourself or have advisors nominate you for professional awards",
    ],
    actionsZh: [
      "申请本领域国家级认可的竞赛",
      "向设有最佳论文奖的顶级会议投稿",
      "申请竞争性奖学金和研究基金",
      "自荐或请导师推荐专业奖项",
    ],
    timelineHint: "Start applying in Year 1 of graduate school",
    timelineHintZh: "研究生第一年开始申请",
  },
  {
    id: 2,
    name: "Membership",
    nameZh: "专业会员",
    description:
      "Membership in associations that require outstanding achievements, as judged by recognized experts.",
    descriptionZh:
      "加入要求杰出成就的专业协会，且入会需经公认专家评审。",
    strongExamples: [
      "IEEE Senior Member (requires peer review and significant contributions)",
      "ACM Distinguished Member or Fellow",
      "National Academy of Inventors member",
      "Elected membership in honor societies with rigorous selection (e.g., Tau Beta Pi, Sigma Xi)",
    ],
    strongExamplesZh: [
      "IEEE高级会员（需同行评审和重要贡献）",
      "ACM杰出会员或会士",
      "国家发明家学会会员",
      "严格选拔的荣誉学会当选会员（如Tau Beta Pi、Sigma Xi）",
    ],
    weakExamples: [
      "Paid memberships open to anyone (e.g., basic IEEE or ACM membership)",
      "Student chapter memberships",
      "LinkedIn professional groups",
      "Alumni associations",
    ],
    weakExamplesZh: [
      "任何人都可付费加入的会员（如基础IEEE或ACM会员）",
      "学生分会会员",
      "LinkedIn专业群组",
      "校友会",
    ],
    actions: [
      "Identify selective associations in your field and work toward eligibility",
      "Build a track record of contributions that meet membership criteria",
      "Ask current members to sponsor your application",
      "Document the selectivity and prestige of any memberships you hold",
    ],
    actionsZh: [
      "识别本领域有选拔性的协会并努力达到资格",
      "积累满足会员标准的贡献记录",
      "请现有会员推荐你的申请",
      "记录所持会员的选拔性和声望",
    ],
    timelineHint: "Begin building eligibility by Year 2; apply by Year 3-4",
    timelineHintZh: "第二年开始积累资格；第三至四年申请",
  },
  {
    id: 3,
    name: "Published Material",
    nameZh: "媒体报道",
    description:
      "Published material in professional or major trade publications or major media about the person and their work.",
    descriptionZh:
      "专业出版物或主流媒体中关于申请人及其工作的已发表材料。",
    strongExamples: [
      "Feature article in major media (e.g., NYT, Wired, BBC) about your work",
      "In-depth profile in a leading trade publication",
      "Interview or quote in industry press about your research impact",
      "Coverage of your work in widely-circulated professional journals",
    ],
    strongExamplesZh: [
      "主流媒体（如纽约时报、连线杂志、BBC）关于你工作的专题报道",
      "行业领先出版物的深度专访",
      "行业媒体就你的研究影响进行的采访或引用",
      "广泛流通的专业期刊对你工作的报道",
    ],
    weakExamples: [
      "Self-published blog posts or Medium articles",
      "University press releases you wrote yourself",
      "Social media mentions or retweets",
      "Brief mentions in passing within larger articles",
    ],
    weakExamplesZh: [
      "自行发布的博客或Medium文章",
      "自己撰写的大学新闻稿",
      "社交媒体提及或转发",
      "大篇幅文章中的简短提及",
    ],
    actions: [
      "Pitch your research findings to science/tech journalists",
      "Respond to media inquiries through your university press office",
      "Write op-eds for trade publications about your area of expertise",
      "Build relationships with reporters who cover your field",
    ],
    actionsZh: [
      "向科技记者推介你的研究成果",
      "通过大学新闻办公室回应媒体咨询",
      "为行业出版物撰写你擅长领域的专家评论",
      "与报道你所在领域的记者建立关系",
    ],
    timelineHint: "Pursue media coverage once you have publishable results (Year 2+)",
    timelineHintZh: "有可发表成果后开始争取媒体报道（第二年起）",
  },
  {
    id: 4,
    name: "Judging",
    nameZh: "评审经历",
    description:
      "Participation as a judge of the work of others in the same or allied field, individually or on a panel.",
    descriptionZh:
      "以个人或小组形式担任同领域或相关领域他人作品的评审。",
    strongExamples: [
      "Peer reviewer for top-tier journals (e.g., Nature, Science, IEEE Transactions)",
      "Program committee member for major conferences",
      "Grant proposal reviewer for funding agencies (NSF, NIH, etc.)",
      "Judge for national competitions or hackathons in your field",
    ],
    strongExamplesZh: [
      "顶级期刊的同行评审（如Nature、Science、IEEE Transactions）",
      "主要会议的程序委员会成员",
      "资助机构（NSF、NIH等）的基金提案评审",
      "本领域全国竞赛或黑客马拉松的评委",
    ],
    weakExamples: [
      "Reviewing classmates' work in a course",
      "Internal code reviews at your company",
      "Grading papers as a teaching assistant",
      "Providing informal feedback to colleagues",
    ],
    weakExamplesZh: [
      "课程中评审同学的作品",
      "公司内部代码审查",
      "作为助教批改作业",
      "非正式地给同事提供反馈",
    ],
    actions: [
      "Volunteer as a reviewer for journals and conferences in your field",
      "Ask your advisor to recommend you to program committees",
      "Serve as a judge for student competitions or hackathons",
      "Document all review invitations and completed reviews",
    ],
    actionsZh: [
      "主动报名成为本领域期刊和会议的审稿人",
      "请导师推荐你加入程序委员会",
      "担任学生竞赛或黑客马拉松的评委",
      "记录所有评审邀请和已完成的评审",
    ],
    timelineHint: "Start reviewing by Year 2 of PhD; build a record by Year 3-4",
    timelineHintZh: "博士第二年开始审稿；第三至四年积累记录",
  },
  {
    id: 5,
    name: "Original Contributions",
    nameZh: "原创贡献",
    description:
      "Original scientific, scholarly, or business-related contributions of major significance in the field.",
    descriptionZh:
      "在本领域具有重大意义的原创科学、学术或商业贡献。",
    strongExamples: [
      "Patent that has been licensed or commercialized",
      "Open-source project widely adopted by the industry (1000+ stars, corporate users)",
      "Algorithm or methodology adopted by other researchers or companies",
      "Published research with high citation count demonstrating field impact",
    ],
    strongExamplesZh: [
      "已获许可或商业化的专利",
      "被行业广泛采用的开源项目（1000+星标、企业用户）",
      "被其他研究者或公司采用的算法或方法论",
      "高引用量的发表研究，展示了领域影响力",
    ],
    weakExamples: [
      "Routine engineering work or product features",
      "Course projects or homework assignments",
      "Incremental improvements without documented impact",
      "Patents filed but never used or cited",
    ],
    weakExamplesZh: [
      "常规工程工作或产品功能",
      "课程项目或作业",
      "无记录影响的渐进改进",
      "已申请但从未使用或被引用的专利",
    ],
    actions: [
      "File patents for novel inventions through your employer or university",
      "Build and maintain open-source projects that solve real problems",
      "Collect evidence of adoption: citations, downloads, testimonials, revenue",
      "Get letters from experts confirming the significance of your contributions",
    ],
    actionsZh: [
      "通过雇主或大学为新发明申请专利",
      "构建和维护解决实际问题的开源项目",
      "收集采用证据：引用量、下载量、推荐信、收入",
      "获取专家确认你贡献重要性的推荐信",
    ],
    timelineHint: "Begin building contributions from Year 1; document impact continuously",
    timelineHintZh: "第一年开始积累贡献；持续记录影响力",
  },
  {
    id: 6,
    name: "Scholarly Articles",
    nameZh: "学术文章",
    description:
      "Authorship of scholarly articles in professional journals or other major media.",
    descriptionZh:
      "在专业期刊或其他主要媒体上发表的学术文章的作者身份。",
    strongExamples: [
      "First-author papers in top-tier peer-reviewed journals",
      "Conference papers at flagship venues (e.g., CVPR, ICML, KDD, CHI)",
      "Book chapters in authoritative academic texts",
      "High-impact publications with significant citation counts",
    ],
    strongExamplesZh: [
      "顶级同行评审期刊的第一作者论文",
      "旗舰会议论文（如CVPR、ICML、KDD、CHI）",
      "权威学术著作中的章节",
      "高引用量的高影响力出版物",
    ],
    weakExamples: [
      "Unrefereed workshop papers or poster abstracts",
      "Self-published or pay-to-publish journal articles",
      "Internal company white papers",
      "Co-authored papers where contribution was minimal",
    ],
    weakExamplesZh: [
      "非评审的研讨会论文或海报摘要",
      "自行出版或付费发表的期刊文章",
      "公司内部白皮书",
      "贡献极少的合著论文",
    ],
    actions: [
      "Publish consistently in respected journals and conferences",
      "Aim for first-author or corresponding-author positions",
      "Build a Google Scholar profile and track your citation metrics",
      "Target venues with high impact factors in your subfield",
    ],
    actionsZh: [
      "在知名期刊和会议上持续发表",
      "争取第一作者或通讯作者的位置",
      "建立Google Scholar档案并跟踪引用指标",
      "瞄准你子领域中高影响因子的发表渠道",
    ],
    timelineHint: "Start publishing by Year 1-2; aim for 3-5+ papers by application time",
    timelineHintZh: "第一至二年开始发表；申请时目标3-5+篇论文",
  },
  {
    id: 7,
    name: "Critical/Essential Role",
    nameZh: "关键角色",
    description:
      "Performance in a critical or essential capacity for organizations with a distinguished reputation.",
    descriptionZh:
      "在具有卓越声誉的组织中担任关键或核心角色。",
    strongExamples: [
      "Lead engineer or architect of a major product at a well-known company",
      "Principal investigator on a significant funded research project",
      "Founding team member of a successful startup (Series A+)",
      "Technical lead of a critical initiative at a Fortune 500 company or top university",
    ],
    strongExamplesZh: [
      "知名公司重要产品的首席工程师或架构师",
      "重大资助研究项目的首席研究员",
      "成功创业公司（A轮+）的创始团队成员",
      "世界500强公司或顶尖大学关键项目的技术负责人",
    ],
    weakExamples: [
      "General software engineer at a large company",
      "Research assistant performing routine tasks",
      "Internship roles without distinguishing responsibilities",
      "Junior position in a team without leadership duties",
    ],
    weakExamplesZh: [
      "大公司的普通软件工程师",
      "执行常规任务的研究助理",
      "无突出职责的实习岗位",
      "团队中无领导职责的初级职位",
    ],
    actions: [
      "Seek leadership roles on high-visibility projects",
      "Document your specific contributions and their impact on the organization",
      "Get letters from senior leaders confirming your essential role",
      "Keep records of projects where you were irreplaceable or uniquely qualified",
    ],
    actionsZh: [
      "争取高曝光项目的领导角色",
      "记录你的具体贡献及对组织的影响",
      "获取高层领导确认你核心角色的推荐信",
      "保留你不可替代或独特胜任的项目记录",
    ],
    timelineHint: "Build toward leadership roles by Year 2-3 of career",
    timelineHintZh: "职业生涯第二至三年争取领导角色",
  },
  {
    id: 8,
    name: "High Salary",
    nameZh: "高薪资",
    description:
      "High salary or other remuneration for services, evidenced by contracts or other reliable evidence.",
    descriptionZh:
      "高薪资或其他服务报酬，需有合同或其他可靠证据。",
    strongExamples: [
      "Total compensation in the top 10% for your occupation and geographic area",
      "Salary significantly above the prevailing wage for your role",
      "Equity compensation or signing bonuses reflecting exceptional value",
      "Consulting fees well above market rate for your expertise level",
    ],
    strongExamplesZh: [
      "总薪酬在你的职业和地区排名前10%",
      "薪资显著高于你所在职位的现行工资水平",
      "反映特殊价值的股权报酬或签约奖金",
      "远高于市场价格的专业咨询费",
    ],
    weakExamples: [
      "Average salary for your position and location",
      "High cost-of-living adjustments without premium above market",
      "Graduate stipend or postdoc salary",
      "Salary high in absolute terms but average for the role in that market",
    ],
    weakExamplesZh: [
      "所在职位和地点的平均薪资",
      "仅反映高生活成本的工资调整",
      "研究生津贴或博后工资",
      "绝对值高但在该市场中属于该角色的平均水平",
    ],
    actions: [
      "Negotiate for top-of-band compensation when accepting offers",
      "Collect salary survey data to prove your compensation is exceptional",
      "Document total compensation including equity, bonuses, and benefits",
      "Use H-1B salary databases (e.g., H1BGrader, LCA data) for comparison",
    ],
    actionsZh: [
      "接受offer时争取薪资范围的上限",
      "收集薪资调查数据以证明你的报酬是特殊的",
      "记录包括股权、奖金和福利在内的总薪酬",
      "使用H-1B薪资数据库（如H1BGrader、LCA数据）进行比较",
    ],
    timelineHint: "Most relevant at time of application with full-time offers",
    timelineHintZh: "在申请时配合全职offer最为相关",
  },
];
